import DomHelper from '../../DomHelper'
import StoreHelper from '../../../store/helper'

export const onDroppableBubbleDragleave = (component, e) => {
  DomHelper.resetElementScale(e.target)
  StoreHelper.setDropTarget(null)
}
